import axios from "axios"
import type { CartShippingAddress } from "@/api/cart"

export interface CheckoutShippingMethod {
  id: string
  label: string
  price: number
}

export interface CheckoutPaymentInstallment {
  value: string
  label: string
  installmentCount: number
  installmentValue: number
  total: number
  interestLabel: string
}

export interface CheckoutOrderSummary {
  ok: boolean
  reload?: boolean
  totals?: {
    subtotal: number
    shippingTotal: number
    total: number
    currency: string
  }
  shippingMethods?: CheckoutShippingMethod[]
  paymentInstallments?: CheckoutPaymentInstallment[]
  selectedShippingMethod?: string | null
}

interface CheckoutSubmitRequestBase {
  shipToDifferentAddress: boolean
  billing: {
    firstName: string
    lastName: string
    email: string
    phone: string
    cpf: string
    country: string
    state: string
    city: string
    postcode: string
    address1: string
    address2?: string
    number?: string
    neighborhood?: string
  }
  shipping?: {
    firstName: string
    lastName: string
    country: string
    state: string
    city: string
    postcode: string
    address1: string
    address2?: string
    number?: string
    neighborhood?: string
  }
  orderNotes?: string
  termsAccepted?: boolean
}

interface CheckoutSubmitRequestNonCard extends CheckoutSubmitRequestBase {
  paymentMethod: "bacs" | "triibo-payments-pix"
}

interface CheckoutSubmitRequestCard extends CheckoutSubmitRequestBase {
  paymentMethod: "triibo-payments-card"
  card: {
    holderName: string
    holderCpf: string
    holderPhone: string
    number: string
    expiry: string
    cvc: string
    brand: string
    installment: string
  }
}

export type CheckoutSubmitRequest =
  | CheckoutSubmitRequestNonCard
  | CheckoutSubmitRequestCard

export interface CheckoutSubmitResponse {
  ok: boolean
  redirectUrl?: string
  code?: string
  message?: string
}

export const getCheckoutOrderSummary = async (
  shippingAddress: CartShippingAddress
): Promise<CheckoutOrderSummary> => {
  const { data } = await axios.post<CheckoutOrderSummary>(
    "/api/checkout/order-review",
    {
      shippingAddress,
    }
  )

  return data
}

export const submitCheckoutOrder = async (
  payload: CheckoutSubmitRequest
): Promise<CheckoutSubmitResponse> => {
  const { data } = await axios.post<CheckoutSubmitResponse>(
    "/api/checkout/submit",
    payload
  )

  return data
}
